import { onReady } from '../lib/on-ready.js';
import { getHash, scrollIntoViewWithOffset } from '../lib/scroll-offset.js';

function initTabsHash() {
    if (!document.querySelector('.tabs-component')) {
        return;
    }

    const url = getHash();
    if (window.screen.width > 768) {
        const tabLink = `#tablink${url || ''}`;
        const targetElement = document.querySelector(tabLink);
        if (targetElement) {
            targetElement.click();
            scrollIntoViewWithOffset(tabLink, 200);
        }
        return;
    }

    const accordionLink = `#accordionlink${url || ''}`;
    const targetElement = document.querySelector(accordionLink);
    if (targetElement) {
        targetElement.click();
        scrollIntoViewWithOffset('#content', -300);
    }
}

onReady(initTabsHash);
